import { NodeType, Schema } from "prosemirror-model";
import { Command, Transaction } from "prosemirror-state";

export function insertHardBreak(schema: Schema<"hard_break", never>): Command {
	return (
		state,
		dispatch
	): boolean => {
		const hardBreakType: NodeType = schema.nodes
			.hard_break;

		const { $from } = state.selection;

		if (!$from.parent
			.contentMatchAt($from.index())
			.matchType(hardBreakType)
		) {
			return false;
		}

		if (dispatch) {
			const tr: Transaction = state.tr;

			tr.replaceSelectionWith(
				hardBreakType.create()
			);

			tr.scrollIntoView();

			dispatch(tr);
		}

		return true;
	};
}